/**
 * Handles selecting a thumbnail by index.
 * Updates selectedIndex in shared state — triggers repaint via notify in handler.
 */
export default class OnFileSelectedHandler {

    /**
     * @param {object} state - shared upload state from UploadAttachmentHandler
     */
    constructor(state) {
        this._state = state;
    }

    /**
     * @param {{ index: number }} data
     */
    handle({ index }) {
        if (index < 0 || index >= this._state.files.length) return;
        this._state.selectedIndex = index;
    }
}
